module.exports = "/CandleActive@2x-9a36a10657e24825ccd2a673e67f069d.png";